/**
 * useLibrarySortStore - 図書館検索結果のソート条件を保持する Zustand ストア
 *
 * リロードごとにリセットされる（永続化なし）。
 * デフォルトは Calil の返却順（relevance / desc）で並び替えを行わない。
 */

import { create } from 'zustand'

export type LibrarySortKey = 'relevance' | 'pubdate' | 'title' | 'author' | 'holdings'

export type LibrarySortOrder = 'asc' | 'desc'

export const DEFAULT_SORT_KEY: LibrarySortKey = 'relevance'
export const DEFAULT_SORT_ORDER: LibrarySortOrder = 'desc'

type LibrarySortState = {
  sortKey: LibrarySortKey
  sortOrder: LibrarySortOrder
  setSort: (key: LibrarySortKey, order: LibrarySortOrder) => void
  reset: () => void
}

export const useLibrarySortStore = create<LibrarySortState>((set) => ({
  sortKey: DEFAULT_SORT_KEY,
  sortOrder: DEFAULT_SORT_ORDER,
  setSort: (key, order) => set({ sortKey: key, sortOrder: order }),
  reset: () => set({ sortKey: DEFAULT_SORT_KEY, sortOrder: DEFAULT_SORT_ORDER }),
}))

export const isDefaultSort = (key: LibrarySortKey, order: LibrarySortOrder): boolean =>
  key === DEFAULT_SORT_KEY && order === DEFAULT_SORT_ORDER
